export default {
  // General UI elements
  save: "Salvar",
  saving: "Salvando",
  cancel: "Cancelar",
  edit: "editar",
  delete: "Excluir",
  profile: "Perfil",
  settings: "Configurações",
  logout: "Sair",
  language: "Idioma",
  loading: "Carregando",
  submit: "Enviar",
  search: "Pesquisar...",
  back: "Voltar",
  next: "Próximo",
  previous: "Anterior",
  continue: "Continuar",
  done: "Concluído",
  error: "Erro",
  success: "Sucesso",
  warning: "Aviso",
  info: "Informação",
  close: "Fechar",
  open: "Abrir",
  yes: "Sim",
  no: "Não",
  ok: "OK",
   
  // Authentication
  auth: {
    signIn: "Entrar",
    signUp: "Cadastrar",
    signOut: "Sair",
    forgotPassword: "Esqueceu a senha?",
    resetPassword: "Redefinir senha",
    sendResetLink: "Enviar link de redefinição",
    createAccount: "Criar conta",
    alreadyHaveAccount: "Já tem uma conta?",
    dontHaveAccount: "Não tem uma conta?",
    or: "Ou",
    continueWith: "Continuar com",
    google: "Google",
    facebook: "Facebook",
    apple: "Apple",
    twitter: "Twitter",
    passwordRequirements: "A senha deve ter pelo menos 8 caracteres",
    passwordMatch: "As senhas devem coincidir",
    emailInvalid: "Por favor, insira um endereço de e-mail válido"
  },
  
  // Profile specific
  username: "Nome de usuário",
  email: "E-mail",
  password: "Senha",
  confirmPassword: "Confirmar senha",
  joinDate: "Data de adesão",
  streak: "Sequência",
  xp: "XP",
  plan: "Plano",
  free: "Gratuito",
  pro: "Pro",
  premium: "Premium",
  referralCode: "Código de indicação",
  share: "Compartilhar",
  copy: "Copiar",
  copied: "Copiado!",
  contactUs: "Contate-nos",
  termsOfService: "Termos de serviço",
  privacyPolicy: "Política de privacidade",
  accountSettings: "Configurações da conta",
  changePassword: "Alterar senha",
  deleteAccount: "Excluir conta",
  deleteAccountConfirm: "Tem certeza de que deseja excluir sua conta? Esta ação não pode ser desfeita.",
  updateProfile: "Atualizar perfil",
  profileUpdated: "Perfil atualizado com sucesso",
  memberSince: "Membro desde",
  noSetsYet: "Ainda Sem Conjuntos :(",
  upgradeToPro: "Atualizar para Pro",
  recentActivity: "Atividade Recente",
  shareWithAFriend: "Compartilhar com um Amigo",
  contactTheTeam: "Contatar a Equipe",
  termsAndConditions: "Termos e Condições",
  editUsername: "Editar Nome de Usuário:",
  logOut: "Sair",
  usernameError1: "O nome de usuário não pode estar vazio",
  usernameError2: "Por favor, insira um nome de usuário diferente ou novo",
  usernameError3: "O nome de usuário não pode conter espaços",
  usernameError4: "O nome de usuário não pode conter letras maiúsculas",
  usernameError5: "O nome de usuário não pode conter caracteres especiais",
  usernameError6: "O nome de usuário deve ter entre 4 e 18 caracteres",
  usernameError7: "O nome de usuário contém conteúdo inadequado",
  usernameError8: "Este nome de usuário já está em uso",
  clickOrDragAndDrop: "Clique ou arraste e solte para carregar",
  confirm: "Confirmar",
  retake: "Refazer",

  // BottomNav
  profile: "Perfil",
  home: "Início",
  library: "Minha Biblioteca",
  saved: "Salvo",
  rankings: "Classificações",

  // Feature
  backToLibrary: "Voltar para a Biblioteca",
  exploreSets: "Explorar Conjuntos",
  communitySets: "Conjuntos da Comunidade",
  mySets: "Meus Conjuntos",
  alreadyAdded: "Já Adicionado",
  addToLibrary: "Adicionar à Biblioteca",
  loading: "Carregando...",
  loadMoreSets: "Carregar Mais Conjuntos",
  by: "Por",
  makePublic: "Tornar Público",
  subscriptionRequired: "Assinatura Obrigatória",
  subscriptionRequiredMessage: "Você só pode ter 10 conjuntos ao mesmo tempo na biblioteca. Atualize para Premium para conjuntos ilimitados!",

  // My Library
  deleteSet: "Excluir Conjunto",
  deleteSetConfirmation: "Tem certeza de que deseja excluir este conjunto?",
  yesDelete: "Sim, Excluir",
  collections: "Conjuntos Públicos",
  myLibrary: "Minha Biblioteca",
  outOf10Sets: "de 10 conjuntos adicionados",
  switchBackToPro: "Voltar para Pro",
  upgradeToPro: "Atualizar para Pro",
  outOf10OnFree: "de 10 conjuntos adicionados gratuitamente.",
  letMeCook: "Deixe-me cozinhar",
  selectMode: "Selecionar Modo",
  multipleChoice: "Escolha Múltipla",
  flashcards: "Cartões Flash",
  freeResponse: "Resposta Livre",
  proOnly: "Apenas para Pro",
  leaderboard: "Classificação",
  favorites: "Favoritos",
  profile: "Perfil",
  reportBugs: "Reportar Erros",

  // Question Card
  correctMessage: "Correto! Você Arrasou.",
  typeYourAnswer: "Digite sua resposta aqui...",
  submitAnswer: "Enviar Resposta",
  responseCannotBeBlank: "A resposta não pode estar em branco",
  noAnswerAvailable: "Nenhuma resposta disponível",
  answerGuideline: "Diretriz de Resposta",
  pleaseSubmitAnswerFirst: "Por favor, envie sua resposta primeiro",
  revealAnswer: "Revelar Resposta",
  hideAnswer: "Esconder Resposta",
  gradingInProgress: "Avaliação em andamento...",
  grading: "Avaliação",
  answerGuidelines: "Diretrizes de Resposta",
  finalScore: "Pontuação Final:",
  evaluateAnswer: "Avaliar Resposta",

  // Saved
  favorites: "Favoritos",
  searchQuestions: "Pesquisar perguntas...",
  noSavedQuestions: "Nenhuma pergunta salva ainda.",

  // Scroller
  loadingMoreQuestions: "Carregando Mais Perguntas",

  // New Prompt
  deleteSet: "Excluir Conjunto",
  deleteSetConfirmation: "Tem certeza de que deseja excluir este conjunto?",
  yesDelete: "Sim, Excluir",
  cancel: "Cancelar",
  setLimitReached: "Limite de Conjunto Alcançado",
  setLimitError: "Você só pode ter 10 conjuntos ao mesmo tempo na biblioteca. Atualize para Premium para conjuntos ilimitados!",
  close: "Fechar",
  uploadNotes: "Carregar Notas",
  general: "Geral",
  title: "Título",
  setTitleMessage: "Defina um título para suas perguntas geradas por AI do Cookr, para que seja fácil de acessar mais tarde.",
  titleError1: "O título não pode estar em branco",
  titleError2: "O título contém conteúdo inapropriado",
  content: "Conteúdo",
  setContentMessage: "Copie e cole suas notas, palestras ou qualquer outro conteúdo textual.",
  contentError1: "O conteúdo não pode estar em branco",
  contentError2: "O conteúdo contém conteúdo inapropriado",
  subject: "Assunto",
  setSubjectMessage: "Qual é o assunto ou tópico deste conteúdo?",
  subjectError1: "O assunto não pode estar em branco",
  subjectError2: "O assunto contém conteúdo inapropriado",

  // Payment Confirmation
  returnToProfile: "Voltar para o Perfil",

  // Plans
  confirmSwitch: "Confirmar Mudança para Plano Grátis",
  confirmSwitchMessage: "Tem certeza de que deseja mudar para o Plano Grátis? Você perderá o acesso a recursos premium.",
  buttonConfirm: "Confirmar Mudança",
  processing: "Processando...",
  unlimitedScrolling: "Rolagem Ilimitada",
  unlimitedSubjects: "Assuntos Ilimitados",
  aiTutorBot: "Bot de Tutor AI",
  newFeatureAccess: "Acesso a Novos Recursos",
  saveScrolls: "Salvar Scrolls",
  infiniteNoteUploads: "Uploads de Notas Ilimitados",
  answerExplanations: "Explicações de Respostas",
  shareScrolls: "Compartilhar Scrolls",
  everythingInStandard: "Tudo no Standard",
  current: "Atual",
  switchOver: "Mudar para",
  forever: "/para sempre",
  monthly: "/mensalmente",
  yearly: "/anualmente",

  // Leaderboard
  leaderboard: "Classificação",

  // Home.js
  pickASubject: "Escolha um assunto para começar sua sessão!",

  // scrollerLoader
  generatingContent: "Gerando Conteúdo...",

  // Dropdown
  choose: "Escolher",
  titleTooLong: "O título não pode conter mais de 100 caracteres",
}

